'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Form = function (_Component) {
	(0, _inherits3.default)(Form, _Component);

	//	Setup a few defaults
	function Form(props) {
		(0, _classCallCheck3.default)(this, Form);

		var _this = (0, _possibleConstructorReturn3.default)(this, (Form.__proto__ || (0, _getPrototypeOf2.default)(Form)).call(this, props));

		_this.state = {
			verbose: false,
			attribs: {
				onSubmit: _this.handleOnSubmit.bind(_this, props.onSubmit)
			}
		};

		_this.debug = _this.debug.bind(_this);
		return _this;
	}

	(0, _createClass3.default)(Form, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return {
				store: this.props.store,
				debug: this.props.debug
			};
		}
	}, {
		key: 'debug',
		value: function debug(obj) {
			if (this.props.debug) {
				console.log('Formality form', obj); // eslint-disable-line no-console
			}
		}
	}, {
		key: 'submit',
		value: function submit() {
			this.form.dispatchEvent(new Event('submit', { cancelable: true }));
		}

		// TODO: might be able to ease up on the validation calling on submit...
		// TODO: might also be able to debounce the change/blur and this one as a group... with a properly extracted validateForm function... probably needs to be memoised though... (so it's chosen by name)

	}, {
		key: 'handleOnSubmit',
		value: function () {
			var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(oldHandler, e) {
				var _this2 = this;

				var fieldValidationResults, validationResults, validationResult;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								e.preventDefault();

								// trigger all the field validations (and re-renders)
								_context2.next = 3;
								return _promise2.default.all((0, _keys2.default)(this.props.store.fieldRefs).map(function () {
									var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(name) {
										var fieldRefs, validationResults, validationResult;
										return _regenerator2.default.wrap(function _callee$(_context) {
											while (1) {
												switch (_context.prev = _context.next) {
													case 0:
														fieldRefs = Array.isArray(_this2.props.store.fieldRefs[name]) ? _this2.props.store.fieldRefs[name] : [_this2.props.store.fieldRefs[name]];
														_context.next = 3;
														return _promise2.default.all(fieldRefs.map(function (fieldRef) {
															return fieldRef.validate(false);
														}));

													case 3:
														validationResults = _context.sent;
														validationResult = validationResults.reduce(function (acc, curr) {
															return [].concat((0, _toConsumableArray3.default)(acc), (0, _toConsumableArray3.default)(curr || []));
														}, []);
														return _context.abrupt('return', (0, _defineProperty3.default)({}, name, validationResult.length ? validationResult : undefined));

													case 6:
													case 'end':
														return _context.stop();
												}
											}
										}, _callee, _this2);
									}));

									return function (_x3) {
										return _ref2.apply(this, arguments);
									};
								}()));

							case 3:
								fieldValidationResults = _context2.sent;
								validationResults = fieldValidationResults.reduce(function (acc, curr) {
									return (0, _extends3.default)({}, acc, curr);
								}, {});
								validationResult = (0, _keys2.default)(validationResults).every(function (key) {
									return !validationResults[key];
								});


								this.props.store.setValidations(validationResults);

								if (oldHandler) {
									oldHandler.apply(this, [e, this.props.store.values, validationResult, validationResults]);
								}

								this.debug({ handleOnSubmit: {
										store: this.props.store,
										validationResult: validationResult,
										validationResults: validationResults,
										hasOldHandler: !!oldHandler
									} });

							case 9:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function handleOnSubmit(_x, _x2) {
				return _ref.apply(this, arguments);
			}

			return handleOnSubmit;
		}()
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var attribs = (0, _extends3.default)({}, this.props, this.state.attribs);

			delete attribs.debug;
			delete attribs.store;
			delete attribs.children;

			return _react2.default.createElement(
				'form',
				(0, _extends3.default)({}, attribs, {
					ref: function ref(el) {
						_this3.form = el;
					}
				}),
				this.props.children
			);
		}
	}]);
	return Form;
}(_react.Component);

Form.childContextTypes = {
	store: _propTypes2.default.object,
	debug: _propTypes2.default.bool
};

Form.propTypes = {
	debug: _propTypes2.default.bool,
	store: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	onSubmit: _propTypes2.default.func,
	children: _propTypes2.default.any // eslint-disable-line react/forbid-prop-types
};

Form.defaultProps = {
	debug: undefined,
	onSubmit: undefined,
	children: undefined
};

var _default = Form;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Form, 'Form', 'src/form.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/form.js');
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/form.js